import { render, staticRenderFns } from "./PianoTerapeuticoDetail.vue?vue&type=template&id=c5c56f82&"
import script from "./PianoTerapeuticoDetail.vue?vue&type=script&lang=js&"
export * from "./PianoTerapeuticoDetail.vue?vue&type=script&lang=js&"
import style0 from "./PianoTerapeuticoDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports